<ng-template [ngIf]="!pane || !pane.loaded" [ngIfElse]="contentBlock">
  <div class="pane-mini">
    <loading-line height="40px" width="100%"></loading-line>
  </div>
</ng-template>

<ng-template #contentBlock>
  <ng-template [ngIf]="filteredPanels(filterPanels)?.length">
    <app-library-title *ngIf="blockTitle?.title" [title]="blockTitle"></app-library-title>

    <div class="categories-content-filter" [class.simple]="displayMode === 'simple'">
      <div class="scroll">
        <div class="categories-wrap">
          <div
            *ngFor="let item of filteredPanels(filterPanels); let i = index; trackBy: trackByFn"
            class="categories-item"
            [style]="{ order: item.order }">
            <app-categories-item
              [link]="routeLinkByItem(item)"
              [panel]="item"
              [displayMode]="displayMode"
              (makeFavorite)="onMakeFavorite(item)"
              (checkActiveTab)="onActiveTabSet($event)">
            </app-categories-item>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="isCustomPage()">
    <app-library-title *ngIf="blockTitle?.title" [title]="blockTitle"></app-library-title>

    <div class="categories-content-filter" [class.simple]="displayMode === 'simple'">
      <div class="scroll">
        <div class="categories-wrap">
          <div *ngFor="let item of customPages(); let i = index; trackBy: trackByFn" class="categories-item">
            <app-categories-item
              [link]="routeLinkByCustomPage(item)"
              [panel]="item"
              [displayMode]="displayMode"
              (makeFavorite)="onMakeFavorite(item)">
            </app-categories-item>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
